import { getToken } from '@/utils/storage'; // getToken from cookie
const filter = {
  // 字符串大于20 ...
  substr(value) {
    if (!value) return '';
    value = value.toString();
    return value.length > 20 ? value.substring(0, 20) + '...' : value;
  },
  // 返回年月日 2021-12-04 15:03:42 => 2021-12-04
  yearMonth(value) {
    if (!value) return '';
    value = value.toString();
    return value.substring(0, 10);
  },
  // 返回年月日 2021-12-04 15:03:42 => 2021-12-04
  monthDay(value) {
    if (!value) return '';
    value = value.toString();
    return value.substring(5, 10);
  },
  titleFilter(val) {
    if (val.length < 1) {
      return '猜你喜欢';
    }
    return val;
  },
  urlAddToken(val) {
    if (val && val.substr(-6) === 'token=' && getToken()) {
      return `${val}${encodeURI(getToken())}`;
    } else if (val && val.substr(-7) === 'userNo=' && getToken()) {
      return `${val}${encodeURI(getToken())}`;
    } else {
      return val ? `${val}` : 'javascript:void(0);';
    }
  }
};
export default filter;
